<template>
<div>
    <Tables ref="tableGrid"
      :columns="columns"
      :showSearch="false"
      :showPrint="false"
      :showDownload="false"
      :showFullscreen="false"
      v-on:Load="onLoad"
    >
              <tr v-for="data in tableData" v-bind:key="data.id">
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.endereco" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.cidade.nome" />
                <TableColumn  v-on:Edit="$emit('edit',data)" :newState="true" :newStatusNumber="0"  :colorStatus="data.colorStatus" :descriptionNewStatus="getStatus(data.status)" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit',data)" :status="1" :value="data.tamanho +  ' M²'" />
              </tr>
    </Tables>

</div>
</template>

<script>
import Tableenterprise from './tableenterprise'
export default Tableenterprise
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/enterprisetable/tableenterprise.vue